export default "__VITE_ASSET__hGiEPoCC__"